import AppContent, { ContentNS } from "content/content";
import LinkButton from "features/shared/components/buttons/link-button/LinkButton";
import SubmitButton from "features/shared/components/buttons/submit-button/SubmitButton";
import Spinner from "features/shared/components/spinner/Spinner";
import Separator from "features/shared/styles/separator/Separator.styled";
import { FC } from "react";

import ConsentButtons from "./styles/ConsentButtons";
// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import StyledPassengerConsent from "./styles/StyledPassengerConsent-APP_CLIENT.styled";
import useSessionConsent from "./hooks/useSessionConsent";

const SessionConsent: FC = () => {
  const text = (s: string) => AppContent.shared.t(s, { ns: ContentNS.consent });
  const [giveConsent, isLoading] = useSessionConsent();

  if (isLoading) {
    return (
      <StyledPassengerConsent>
        <Separator />
        <Spinner />
      </StyledPassengerConsent>
    );
  }

  return (
    <StyledPassengerConsent>
      <Separator />
      <ConsentButtons>
        <SubmitButton onClick={() => giveConsent(true)} isLoading={isLoading}>
          {text("submit-consent-button")}
        </SubmitButton>
        <div>
          <LinkButton onClick={() => giveConsent(false)}>
            {text("continue-without-consent")}
          </LinkButton>
        </div>
      </ConsentButtons>
    </StyledPassengerConsent>
  );
};

export default SessionConsent;
